import React from 'react'
import moment from 'moment'
import cl from 'classnames'
import swal from "sweetalert2"
import Modal from 'components/Modal'
import lodash from 'lodash'
import { smoothScroll, formatNumber, img, commingSoonFnc, isStartEvent } from 'components/common'
import ReactTooltip from 'react-tooltip'
class GiftSection extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            modal: null,
            isMobile: false,
            medal: 0,
            medal_prizes: null,
            site_info: null,
        }
    }
    handleClosePopup() {
        this.setState({ modal: null })
        $('body').removeClass('modal-open');
    }
    handleOpenPopup(modal) {
        this.setState({ modal: modal })
        $('body').addClass('modal-open');
    }
    componentDidMount() {
        if ($(window).width() < 1023) {
            this.setState({
                isMobile: true,
            })
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.parentProp.home.user != null && !nextProps.parentProp.home.loading) {
            this.setState({
                medal: nextProps.parentProp.home.user.medal
            })
        }
        if (nextProps.parentProp.home.medal_prizes != null && !nextProps.parentProp.home.loading) {
            this.setState({
                medal_prizes: nextProps.parentProp.home.medal_prizes
            })
        }
        if (nextProps.parentProp.home.site_info != null && !nextProps.parentProp.home.loading) {
            this.setState({
                site_info: nextProps.parentProp.home.site_info
            })
        }

    }
    claimMedal(stage) {
        this.props.parentProp.calimStage(stage.toString())
    }
    render() {
        const { modal, isMobile, medal, medal_prizes, site_info } = this.state
        return (
            <React.Fragment>
                <section className="sec-gift">
                    {/* <div className="wrap-bg-animate"></div> */}
                    <div className="wrap-content">
                        <h3 className="page-title" data-aos="zoom-in-down">
                            <span className="p-title">quà tích lũy</span>
                        </h3>
                        <p className="des" data-aos="fade-left">
                            Tích lũy Token từ việc hoàn thành hết nhiệm vụ thường trong 1 tuần. Khi đạt đủ mốc Token tương ứng, bạn sẽ nhận được thêm những phần quà giá trị. Click để nhận quà.
                        </p>
                        <p className="count" data-aos="fade-right">Số huy hiệu hiện có <b>{medal}</b></p>
                        <ul className="shop-exchange" data-aos="fade-up" data-aos-delay="200">
                            {medal_prizes &&
                                medal_prizes.map((item, index) => (
                                    <li key={index}>
                                        {
                                            item.server_rewards && item.server_rewards.map((reward, index) => (
                                                <div className="wrap-img-gif">
                                                    <img src={reward.image} alt="" className="gift" />
                                                </div>
                                            ))
                                        }
                                        <a href="javascript:void(0)" onClick={() => this.claimMedal(item.stage)}>
                                            <span>{item.stage} token</span><i>{img('images/icon_token.png', 'icon')}</i>
                                        </a>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </section>
            </React.Fragment>
        )
    }
}

export default GiftSection



// WEBPACK FOOTER //
// ./src/components/event/GiftSection.js